/**
 * @fileoverview Prompt template for inspiration-ideas-generator-v2.
 *
 * Generates three distinct story concepts inspired by existing stories.
 * Unlike the deprecated story-inspirer-v2, this agent only produces simple ideas (title + summary),
 * which are then expanded by the plot-planner agents.
 */

export const prompt = `
You are an expert narrative designer specializing in creative adaptation and thematic resonance.

## TASK INSTRUCTIONS:
Generate three distinct story ideas INSPIRED BY the provided source stories. The new stories should evoke similar feelings, themes, or settings but be wholly original—no direct characters, plot points, or settings from the sources.

APPROACH:
(1) Analyze the source stories for:
    - Core themes and emotional throughlines
    - Atmospheric and tonal qualities
    - Character archetypes and dynamics
    - World-building elements worth drawing from
    - Narrative structures that work well
(2) Brainstorm 10-15 possible original stories that draw inspiration from these elements.
(3) Distill into exactly three distinct ideas. Each should:
    - Feel spiritually connected to the sources
    - Be completely original (no copied characters, plots, or specific settings)
    - Offer a genuinely different creative direction from the other two

<<<userMessage>>>

## TASK CONTEXT
<<<storyContext>>>
<<<loreContext>>>

## INSPIRATIONAL STORIES
{{#each existingStories}}
**Story {{add @index 1}}:**
{{{this}}}

***
{{/each}}

## OUTPUT INSTRUCTIONS:
For each idea, provide:
- **title**: A compelling, evocative title
- **summary**: A 100-word concept summary describing the core premise, main character(s), and central conflict. Do NOT include detailed plot breakdowns, three-act structures, or character lists.

Provide your output in the required JSON format.
`;
